import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {Institution} from "../../models/institution";
import {Registration} from "../../models/registration";
import {RegistrationInstitution} from "../../models/registration-institution";
import {Role} from "../../models/role";
import {RoleInstitution} from "../../models/role-institution";

@Directive()
@Injectable()
export class InstitutionService {

  public institution: Institution;
  public institutions: Institution[];

  public registration: Registration;
  public registrationInstitution: RegistrationInstitution;
  public registrationUnitsLength: number = 0;

  public role: Role;
  public roleInstitutions: RoleInstitution[];
  public roleUnitsLength: number = 0;

  public addNew: boolean;

  @Output() public editData: EventEmitter<any> = new EventEmitter();
  @Output() public change: EventEmitter<any> = new EventEmitter();
  @Output() public update: EventEmitter<any> = new EventEmitter();

  public initEdit() {
    this.editData.emit({
      institution: this.institution,
      addNew: this.addNew,
      registration: this.registration,
      registrationInstitution: this.registrationInstitution,
      registrationUnitsLength: this.registrationUnitsLength,
      role: this.role,
      roleInstitutions: this.roleInstitutions,
      roleUnitsLength: this.roleUnitsLength,
    });
    this.resetData();
  }

  public resetData() {
    this.institution = null;
    this.institutions = null;

    this.registration = null;
    this.registrationInstitution = null;
    this.registrationUnitsLength = 0;

    this.role = null;
    this.roleInstitutions = null;
    this.roleUnitsLength = 0;

    this.addNew = null;
  }

  public updateData() {
    this.update.emit({
      update: true,
    });
  }

}
